import React from 'react';

const SkeletonBlock = ({ className }) => (
  <div className={`animate-pulse rounded-lg bg-white/40 ${className}`} />
);

const CardShell = ({ children, className = '' }) => (
  <div className={`bg-white/30 backdrop-blur-sm p-6 rounded-2xl ${className}`}>
    {children}
  </div>
);

const WeatherSummarySkeleton = () => (
  <CardShell className="text-white">
    <div className="space-y-4">
      <SkeletonBlock className="h-7 w-40" />
      <SkeletonBlock className="h-5 w-48" />
      <div className="flex items-end gap-3">
        <SkeletonBlock className="h-16 w-32" />
        <SkeletonBlock className="h-10 w-16" />
      </div>
    </div>
  </CardShell>
);

const SideCardsSkeleton = () => (
  <div className="flex flex-col sm:flex-row xl:flex-col gap-4 xl:gap-3">
    <CardShell>
      <div className="space-y-3">
        <SkeletonBlock className="h-16 w-16 rounded-2xl" />
        <SkeletonBlock className="h-4 w-28" />
        <SkeletonBlock className="h-4 w-36" />
        <SkeletonBlock className="h-4 w-36" />
      </div>
    </CardShell>
    <CardShell>
      <SkeletonBlock className="h-5 w-36 mb-3" />
      <div className="space-y-3">
        <SkeletonBlock className="h-4 w-40" />
        <SkeletonBlock className="h-4 w-40" />
        <SkeletonBlock className="h-4 w-40" />
        <SkeletonBlock className="h-4 w-40" />
      </div>
    </CardShell>
  </div>
);

const HourlyCardSkeleton = () => (
  <CardShell>
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center gap-2">
        <SkeletonBlock className="h-8 w-10" />
        <SkeletonBlock className="h-5 w-16" />
        <SkeletonBlock className="h-8 w-10" />
      </div>
    </div>
    <div className="grid grid-cols-4 md:grid-cols-6 gap-4">
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="rounded-lg bg-gray-100/70 p-3 space-y-3 min-w-0">
          <SkeletonBlock className="h-4 w-3/4" />
          <SkeletonBlock className="h-8 w-8 rounded-full" />
          <SkeletonBlock className="h-5 w-1/2" />
        </div>
      ))}
      {Array.from({ length: 2 }).map((_, i) => (
        <div key={`md-${i}`} className="hidden md:block rounded-lg bg-gray-100/70 p-3 space-y-3 min-w-0">
          <SkeletonBlock className="h-4 w-3/4" />
          <SkeletonBlock className="h-8 w-8 rounded-full" />
          <SkeletonBlock className="h-5 w-1/2" />
        </div>
      ))}
    </div>
  </CardShell>
);

const WeeklyForecastSkeleton = () => (
  <CardShell>
    <SkeletonBlock className="h-7 w-48 mb-4" />
    <div className="grid grid-cols-7 gap-3">
      {Array.from({ length: 7 }).map((_, i) => (
        <div key={i} className="rounded-xl bg-white/40 p-4 space-y-3 min-w-0">
          <SkeletonBlock className="h-4 w-3/4" />
          <SkeletonBlock className="h-3 w-1/2" />
          <SkeletonBlock className="h-10 w-10 rounded-full" />
          <SkeletonBlock className="h-4 w-2/3" />
          <SkeletonBlock className="h-4 w-3/4" />
        </div>
      ))}
    </div>
  </CardShell>
);

const DashboardSkeleton = () => {
  return (
    <div className="flex-1 p-6 overflow-y-auto flex flex-col">
      <div className="flex-1 flex flex-col justify-end min-h-0 gap-6">
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
          <WeatherSummarySkeleton />
          <HourlyCardSkeleton />
          <SideCardsSkeleton />
        </div>
        <WeeklyForecastSkeleton />
      </div>
    </div>
  );
};

export default DashboardSkeleton;


